export const OrderBy = {
  ASC: 'asc',
  DESC: 'desc',
};
